export enum SectionState {
    CLOSED = '0',
    OPEN= '1'
  }